import React, { useEffect, useRef } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import useMatriculasLogic from "./hooks/useMatriculasLogic";
import MatriculasView from "./pages/MatriculasView.jsx";
import { obtenerMatricula } from "../../../services/matriculasService";
import { obtenerEstudiante } from "../../../services/estudiantesService";
import { normalizeMatricula } from "./adapters/matriculasAdapter";

export default function Matriculas() {
  const location = useLocation();
  const navigate = useNavigate();
  const openedRef = useRef(new Set());
  const logic = useMatriculasLogic();
  const { matriculas, form, loading } = logic;

  useEffect(() => {
    const search = location?.search || "";
    if (!search) return;
    const params = new URLSearchParams(search);
    const rawId = params.get("matriculaId") || params.get("matricula_id");
    const tabParam = params.get("tab") || "";
    const matriculaId = rawId ? Number(rawId) : null;
    if (!matriculaId || Number.isNaN(matriculaId)) return;
    const tabKey = tabParam.toLowerCase() === "entregables" ? "entregables" : "datos";
    const openKey = `${matriculaId}:${tabKey}`;
    if (openedRef.current.has(openKey)) return;
    if (loading) return;
    const registro = (matriculas || []).find((item) => Number(item.id) === matriculaId);
    if (registro) {
      openedRef.current.add(openKey);
      form.abrirEditar(registro, { openModal: true, tab: tabKey });
    } else {
      openedRef.current.add(openKey);
      obtenerMatricula(matriculaId)
        .then((detalle) => {
          if (detalle) form.abrirEditar(normalizeMatricula(detalle), { openModal: true, tab: tabKey });
        })
        .catch(() => {});
    }
  }, [location?.search, matriculas, form, loading]);

  // ?nuevaParaEstudiante=X (viene de "Matricular" en Interesados): abre el
  // formulario de nueva matrícula con el estudiante ya seleccionado. Se usa
  // el id directo porque el buscador solo lista estudiantes 'inscrito'.
  useEffect(() => {
    const params = new URLSearchParams(location?.search || "");
    const estudianteId = Number(params.get("nuevaParaEstudiante"));
    if (!estudianteId) return;
    const openKey = `nueva:${estudianteId}`;
    if (openedRef.current.has(openKey)) return;
    openedRef.current.add(openKey);
    navigate(location.pathname, { replace: true });
    obtenerEstudiante(estudianteId)
      .then((est) => {
        if (!est) return;
        form.abrirCrear();
        form.seleccionarEstudiante({
          id: est.id ?? estudianteId,
          nombres: est.nombres,
          apellidos: est.apellidos,
          documento_identidad: est.documento_identidad,
          estado_academico: est.estado_academico,
        }, "nuevo");
      })
      .catch(() => {});
  }, [location?.search, location?.pathname, navigate, form]);

  return (
    <Routes>
      <Route path="/" element={<MatriculasView {...logic} />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
